(() => {
  if (customElements.get('nordsign-category-tree')) return;
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  class CategoryTree extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.directoryClick = event => {
        const link = event.target.closest('header-drawer .ns-db-menu__all');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const destination = new URL(link.href);
        if (destination.origin !== location.origin || destination.pathname !== location.pathname || destination.search !== location.search || destination.hash !== '#category-directory') return;
        const drawer = link.closest('header-drawer');
        const summary = drawer.mainDetailsToggle?.querySelector('summary');
        if (!summary || typeof drawer.closeMenuDrawer !== 'function') return;
        drawer.closeMenuDrawer(event, summary);
        summary.setAttribute('aria-expanded', 'false');
        requestAnimationFrame(() => this.focus({ preventScroll: true }));
      };
      document.addEventListener('click', this.directoryClick);
      try {
        this.records = JSON.parse(this.querySelector('[data-category-tree]').textContent);
        const liveData = this.querySelector('[data-category-live]');
        this.records = window.nordsignCategoryModel(this.records, JSON.parse(liveData?.textContent || '[]')).records;
        this.build();
      } catch (error) {
        console.warn('Category directory could not load', error);
      }
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.directoryClick);
      this.ready = false;
    }
    build() {
      const model = window.nordsignCategoryModel(this.records);
      this.rows = model.rows;
      this.childCategories = model.children;
      this.rootPath = (this.dataset.root || '/').replace(/\/$/, '');
      this.input = this.querySelector('input');
      this.status = this.querySelector('[role=status]');
      this.querySelector('.ns-tree__tools').hidden = false;
      this.input.addEventListener('input', () => this.render(this.input.value.trim().toLocaleLowerCase(this.dataset.lang)));
      this.render('');
      this.dataset.source = model.source;
    }
    link(row, text) {
      const a = element('a', text || row.name);
      a.href = this.rootPath + row.url;
      return a;
    }
    render(query) {
      const matches = new Set();
      const visit = (row, inherited = false) => {
        const own = inherited || row.name.toLocaleLowerCase(this.dataset.lang).includes(query);
        let descendant = false;
        for (const child of this.childCategories(row.key)) descendant = visit(child, own) || descendant;
        if (own || descendant) matches.add(row.key);
        return own || descendant;
      };
      const roots = this.childCategories('root');
      roots.forEach(r => visit(r));
      const content = document.createDocumentFragment();
      const jump = this.querySelector('.ns-tree__jump');
      jump.replaceChildren();
      const branch = row => {
        const children = this.childCategories(row.key).filter(r => matches.has(r.key));
        if (!children.length) {
          const item = element('li');
          item.append(row.url ? this.link(row) : element('span', row.name));
          return item;
        }
        const details = element('details', '', 'ns-tree__branch');
        details.open = true;
        details.append(element('summary', row.name));
        const list = element('ul');
        if (row.url) {
          const overview = element('li', '', 'ns-tree__overview');
          overview.append(this.link(row, this.dataset.browse + ' \u2192'));
          list.append(overview);
        }
        children.forEach(child => {
          const childBranch = branch(child);
          if (childBranch.tagName === 'LI') list.append(childBranch);
          else { const li = element('li'); li.append(childBranch); list.append(li); }
        });
        details.append(list);
        return details;
      };
      for (const root of roots.filter(r => matches.has(r.key))) {
        const section = element('section', '', 'ns-tree__group');
        section.id = `tree-${root.key}`;
        const heading = element(this.dataset.groupHeading || 'h2');
        heading.append(root.url ? this.link(root) : element('span', root.name));
        section.append(heading);
        const columns = element('div', '', 'ns-tree__branches');
        this.childCategories(root.key).filter(r => matches.has(r.key)).forEach(r => {
          const node = branch(r);
          if (node.tagName === 'LI') { const list = element('ul', '', 'ns-tree__branch'); list.append(node); columns.append(list); }
          else columns.append(node);
        });
        section.append(columns);
        content.append(section);
        const a = element('a', root.name);
        a.href = '#' + section.id;
        jump.append(a);
      }
      if (!matches.size) content.append(element('p', this.dataset.empty));
      this.querySelector('.ns-tree__content').replaceChildren(content);
      jump.hidden = !matches.size;
      const noun = this.dataset.lang === 'da' ? 'kategorier' : 'categories';
      this.status.textContent = this.dataset.lang === 'pl' ? `Liczba kategorii: ${matches.size}` : `${matches.size} ${noun}`;
    }
  }
  customElements.define('nordsign-category-tree', CategoryTree);
})();
